import SectionTitle from "../Common/SectionTitle";
import { RiDoubleQuotesL } from "react-icons/ri";

const TESTIMONIALS = [
    {
        key: "1",
        name: "Ekin",
        position: "Freelance",
        company: "-",
        quote: "Natanael delivered a reliable webhook monitoring automation that instantly detects failures and generates detailed logs for investigation. He worked quickly, paid close attention to detail, and communicated exceptionally well throughout the project. His ability to understand requirements, explain technical concepts clearly, and deliver exactly what was needed made the entire process seamless.",
        avatar: null,
        initials: "EK",
    },
    {
        key: "2",
        name: "Sarah Wijaya",
        position: "Project Coordinator",
        company: "Student Organization Platform",
        quote: "Natanael developed a comprehensive dashboard platform for managing student activities and modules, delivering every requirement with exceptional attention to detail. He took the time to understand both the functional needs and user expectations, ensuring the final product aligned perfectly with our vision. The project was completed professionally, with excellent communication and a strong focus on user experience. I highly recommend him for any web development project.",
        avatar: null,
        initials: "SW",
    },
];

const Avatar = ({ initials }) => (
    <div
        style={{
            width: "44px",
            height: "44px",
            borderRadius: "50%",
            background: "rgba(200,151,42,0.12)",
            border: "1px solid rgba(200,151,42,0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            color: "#C8972A",
            fontWeight: 700,
            fontSize: "14px",
            letterSpacing: "0.05em",
        }}
    >
        {initials}
    </div>
);

const TestimonialCard = ({ item }) => (
    <div
        className="flex flex-col gap-4 p-5 rounded-xl transition-all duration-200"
        style={{
            background: "rgba(255,255,255,0.03)",
            border: "1px solid rgba(255,255,255,0.08)",
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(200,151,42,0.04)";
            e.currentTarget.style.borderColor = "rgba(200,151,42,0.18)";
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(255,255,255,0.03)";
            e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)";
        }}
    >
        {/* Quote icon */}
        <RiDoubleQuotesL
            size={22}
            style={{ color: "rgba(200,151,42,0.35)", flexShrink: 0 }}
        />

        {/* Quote text */}
        <p
            className="text-gray-300 leading-relaxed flex-1"
            style={{ fontSize: "13px", fontStyle: "italic" }}
        >
            {item.quote}
        </p>

        {/* Author */}
        <div className="flex items-center gap-3 mt-1">
            <Avatar initials={item.initials} />
            <div>
                <p
                    className="font-semibold text-white"
                    style={{ fontSize: "13px" }}
                >
                    {item.name}
                </p>
                <p
                    style={{
                        fontSize: "11px",
                        color: "rgba(200,151,42,0.7)",
                        marginTop: "1px",
                    }}
                >
                    {item.position} · {item.company}
                </p>
            </div>
        </div>
    </div>
);

const Testimonials = () => (
    <>
        <SectionTitle SectionName="Testimonials" />

        <p
            className="mt-4 text-gray-400 leading-relaxed"
            style={{ fontSize: "14px", maxWidth: "520px" }}
        >
            What colleagues and clients say about working with me.
        </p>

        {/* Note banner — easy to remove once real testimonials are added */}
        <div
            className="mt-5 mb-6 flex items-center gap-2 px-4 py-3 rounded-lg"
            style={{
                background: "rgba(200,151,42,0.06)",
                border: "1px solid rgba(200,151,42,0.18)",
            }}
        >
            <span
                style={{
                    width: "5px",
                    height: "5px",
                    borderRadius: "50%",
                    background: "#C8972A",
                    flexShrink: 0,
                }}
            />
            <span className="text-gray-400" style={{ fontSize: "12px" }}>
                Placeholder data — replace with real testimonials in{" "}
                <code
                    style={{
                        fontFamily: "monospace",
                        fontSize: "11px",
                        color: "#C8972A",
                    }}
                >
                    src/Component/MainContent/Testimonials.js
                </code>
            </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {TESTIMONIALS.map((item) => (
                <TestimonialCard key={item.key} item={item} />
            ))}
        </div>
    </>
);

export default Testimonials;
